import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _excluded = ["src"];
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { Svg as SvgEmotion } from './styles';
import { Preloader } from '../Preloader';
import { IconAccept, IconAcceptM, IconAgreement, IconApple, IconArrowDown, IconArrowDownThin, IconArrowLeft, IconArrowRight, IconBankCard, IconCalendar, IconCapture, IconCheck, IconClose, IconCloseM, IconCopy, IconDecline, IconDeclineM, IconDropdown, IconEdit, IconExclamationMark, IconEyeClosed, IconEyeOpen, IconFilter, IconInfo, IconInfoM, IconInfoSign, IconKyc, IconLocker, IconLogin, IconLogout, IconMastercard, IconMenu, IconMinus, IconMinusThin, IconOrderAlert, IconOrderOk, IconPassport, IconPlus, IconPlusThin, IconProfile, IconQuestion, IconQuestionSign, IconQuestionStroke, IconSearch, IconSecurity, IconShare, IconSorting, IconSupport, IconTelegram, IconTrash, IconTwitter, IconVisa, IconWarning, IconWireTransfer, IconYoutube, IconGear, IconGooglePlay, IconMasterCardMini, IconApplePay, IconGooglePay, IconBank, IconCard, IconBook, IconAffiliates, IconDocument, IconLogOut, IconInstagram, IconFacebook, IconGoogle, IconEmail } from './icons';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export var Svg = function Svg(props) {
  return _jsx(SvgEmotion, _objectSpread({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    "aria-hidden": "true"
  }, props));
};
export var IconSvg = function IconSvg(props) {
  var src = props.src,
    restProps = _objectWithoutProperties(props, _excluded);
  switch (src) {
    case 'check':
      return _jsx(IconCheck, _objectSpread({}, restProps));
    case 'preloader':
      return _jsx(Preloader, {
        size: restProps.width,
        color: restProps.color
      });
    case 'question':
      return _jsx(IconQuestion, _objectSpread({}, restProps));
    case 'question-stroke':
      return _jsx(IconQuestionStroke, _objectSpread({}, restProps));
    case 'arrowLeft':
      return _jsx(IconArrowLeft, _objectSpread({}, restProps));
    case 'close':
      return _jsx(IconClose, _objectSpread({}, restProps));
    case 'close-m':
      return _jsx(IconCloseM, _objectSpread({}, restProps));
    case 'copy':
      return _jsx(IconCopy, _objectSpread({}, restProps));
    case 'dropdown':
      return _jsx(IconDropdown, _objectSpread({}, restProps));
    case 'eye-open':
      return _jsx(IconEyeOpen, _objectSpread({}, restProps));
    case 'eye-closed':
      return _jsx(IconEyeClosed, _objectSpread({}, restProps));
    case 'calendar':
      return _jsx(IconCalendar, _objectSpread({}, restProps));
    case 'edit':
      return _jsx(IconEdit, _objectSpread({}, restProps));
    case 'menu':
      return _jsx(IconMenu, _objectSpread({}, restProps));
    case 'sorting':
      return _jsx(IconSorting, _objectSpread({}, restProps));
    case 'agreement':
      return _jsx(IconAgreement, _objectSpread({}, restProps));
    case 'plus':
      return _jsx(IconPlus, _objectSpread({}, restProps));
    case 'minus':
      return _jsx(IconMinus, _objectSpread({}, restProps));
    case 'plus-thin':
      return _jsx(IconPlusThin, _objectSpread({}, restProps));
    case 'minus-thin':
      return _jsx(IconMinusThin, _objectSpread({}, restProps));
    case 'decline':
      return _jsx(IconDecline, _objectSpread({}, restProps));
    case 'accept':
      return _jsx(IconAccept, _objectSpread({}, restProps));
    case 'info':
      return _jsx(IconInfo, _objectSpread({}, restProps));
    case 'decline-m':
      return _jsx(IconDeclineM, _objectSpread({}, restProps));
    case 'accept-m':
      return _jsx(IconAcceptM, _objectSpread({}, restProps));
    case 'security':
      return _jsx(IconSecurity, _objectSpread({}, restProps));
    case 'passport':
      return _jsx(IconPassport, _objectSpread({}, restProps));
    case 'support':
      return _jsx(IconSupport, _objectSpread({}, restProps));
    case 'logout':
      return _jsx(IconLogout, _objectSpread({}, restProps));
    case 'login':
      return _jsx(IconLogin, _objectSpread({}, restProps));
    case 'locker':
      return _jsx(IconLocker, _objectSpread({}, restProps));
    case 'capture':
      return _jsx(IconCapture, _objectSpread({}, restProps));
    case 'search':
      return _jsx(IconSearch, _objectSpread({}, restProps));
    case 'arrow-down':
      return _jsx(IconArrowDown, _objectSpread({}, restProps));
    case 'arrow-down-thin':
      return _jsx(IconArrowDownThin, _objectSpread({}, restProps));
    case 'info-m':
      return _jsx(IconInfoM, _objectSpread({}, restProps));
    case 'info-sign':
      return _jsx(IconInfoSign, _objectSpread({}, restProps));
    case 'question-sign':
      return _jsx(IconQuestionSign, _objectSpread({}, restProps));
    case 'bank-card':
      return _jsx(IconBankCard, _objectSpread({}, restProps));
    case 'wire-transfer':
      return _jsx(IconWireTransfer, _objectSpread({}, restProps));
    case 'profile':
      return _jsx(IconProfile, _objectSpread({}, restProps));
    case 'kyc':
      return _jsx(IconKyc, _objectSpread({}, restProps));
    case 'filter':
      return _jsx(IconFilter, _objectSpread({}, restProps));
    case 'share':
      return _jsx(IconShare, _objectSpread({}, restProps));
    case 'arrow-right':
      return _jsx(IconArrowRight, _objectSpread({}, restProps));
    case 'trash':
      return _jsx(IconTrash, _objectSpread({}, restProps));
    case 'exclamationMark':
      return _jsx(IconExclamationMark, _objectSpread({}, restProps));
    case 'visa':
      return _jsx(IconVisa, _objectSpread({}, restProps));
    case 'mastercard':
      return _jsx(IconMastercard, _objectSpread({}, restProps));
    case 'order-ok':
      return _jsx(IconOrderOk, _objectSpread({}, restProps));
    case 'order-alert':
      return _jsx(IconOrderAlert, _objectSpread({}, restProps));
    case 'warning':
      return _jsx(IconWarning, _objectSpread({}, restProps));
    case 'gear':
      return _jsx(IconGear, _objectSpread({}, restProps));
    case 'apple':
      return _jsx(IconApple, _objectSpread({}, restProps));
    case 'telegram':
      return _jsx(IconTelegram, _objectSpread({}, restProps));
    case 'youtube':
      return _jsx(IconYoutube, _objectSpread({}, restProps));
    case 'twitter':
      return _jsx(IconTwitter, _objectSpread({}, restProps));
    case 'instagram':
      return _jsx(IconInstagram, _objectSpread({}, restProps));
    case 'facebook':
      return _jsx(IconFacebook, _objectSpread({}, restProps));
    case 'google-play':
      return _jsx(IconGooglePlay, _objectSpread({}, restProps));
    case 'mastercard-mini':
      return _jsx(IconMasterCardMini, _objectSpread({}, restProps));
    case 'apple-pay':
      return _jsx(IconApplePay, _objectSpread({}, restProps));
    case 'google-pay':
      return _jsx(IconGooglePay, _objectSpread({}, restProps));
    case 'bank':
      return _jsx(IconBank, _objectSpread({}, restProps));
    case 'card':
      return _jsx(IconCard, _objectSpread({}, restProps));
    case 'book':
      return _jsx(IconBook, _objectSpread({}, restProps));
    case 'affiliates':
      return _jsx(IconAffiliates, _objectSpread({}, restProps));
    case 'document':
      return _jsx(IconDocument, _objectSpread({}, restProps));
    case 'log-out':
      return _jsx(IconLogOut, _objectSpread({}, restProps));
    case 'google':
      return _jsx(IconGoogle, _objectSpread({}, restProps));
    case 'email':
      return _jsx(IconEmail, _objectSpread({}, restProps));
    default:
      return null;
  }
};
export { Svg as SvgEmotion } from './styles';
//# sourceMappingURL=index.js.map